







































import IconSyncData from '@/app/ui/assets/badge_popup_sync_data.vue'
import Button from '@/app/ui/components/Button/index.vue'
import Teleport from '@/app/ui/components/Teleport/index.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Teleport,
    IconSyncData,
    Button,
  },
})
export default class ForceUpdatePasswordModal extends Vue {
  @Prop({default: false, type: Boolean, required: true}) public disabled!: boolean
}
